import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { BonusConfiguration } from './configuration';
import { HttpClient } from '@angular/common/http';

import { BonusService } from './api/bonus.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class BonusApiModule {
    public static forRoot(configurationFactory: () => BonusConfiguration): ModuleWithProviders<BonusApiModule> {
        return {
            ngModule: BonusApiModule,
            providers: [ { provide: BonusConfiguration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: BonusApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('BonusApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
